import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { fileObject } from '@/types'
import AppConfig from '@/config'
import { useDevStore } from '@/stores/dev'
import { useThreadStore } from '@/stores/thread'

export const useComposerStore = defineStore('composer', () => {
	const currentFile = ref<fileObject>({ name: '', size: 0, type: '' })
	const currentMessage = ref('')
	const reasoning = ref(false)

	function setCurrentFile(file: File) {
		if (currentFile.value.previewUrl) {
			URL.revokeObjectURL(currentFile.value.previewUrl)
		}
		currentFile.value = {
			name: file.name,
			size: file.size,
			type: file.type,
			document: file,
			previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : undefined
		}
	}

	function clearCurrentFile() {
		if (currentFile.value.previewUrl) {
			URL.revokeObjectURL(currentFile.value.previewUrl)
		}
		currentFile.value = { name: '', size: 0, type: '' }
	}

	function setCurrentMessage(message: string) {
		currentMessage.value = message
	}

	function clearCurrentMessage() {
		currentMessage.value = ''
	}

	function toggleReasoningMode() {
		reasoning.value = !reasoning.value
	}

	function clearReasoningMode() {
		reasoning.value = false
	}

	function getModelName(dataModelName: string = '', newThread: boolean = false): string {
		const imgMode = useThreadStore().imgMode
		if (AppConfig.devSetting && !imgMode) {
			return String(useDevStore().currentModel)
		}
		if (newThread && imgMode) {
			return AppConfig.modelName
		}
		if (dataModelName && (newThread || currentFile.value.name)) {
			return dataModelName
		}
		if (reasoning.value) {
			return AppConfig.modelNameReasoning
		}
		if (dataModelName) {
			return dataModelName
		}
		return AppConfig.modelName
	}

	return {
		currentFile,
		currentMessage,
		reasoning,
		setCurrentFile,
		clearCurrentFile,
		setCurrentMessage,
		clearCurrentMessage,
		toggleReasoningMode,
		clearReasoningMode,
		getModelName
	}
})
